import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class LogisticsVehiclesDisplayListComponent implements IController {

  ids: any;
  isRow: any;
  rowLimit: any;
  disabledIds: any;

  onChange: Function;

  private logisticsVehiclesRef: any;
  private displayItems: any;

  constructor(private $logisticsVehicle, private $log) {
  }

  $onInit() {
    this.logisticsVehiclesRef = this.$logisticsVehicle();

    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    this.setItems(this.ids);
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }
  }

  onRemoveItem(id) {
    this.onChange({
      ids: _.filter(this.ids, (i) => {
        return i !== id
      })
    });
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    if (ids && ids.length) {
      this.logisticsVehiclesRef.$asyncValues(ids)
        .then((accounts) => {
          const displayItems = [];
          _.forEach(accounts, (a) => {
            displayItems.push({id: a.id, value: a.name})
          })
          this.displayItems = displayItems;
        })
        .catch((error) => {
          this.$log.error('Failed to get branches', error);
        })
    } else {
      this.displayItems = [];
    }
  }


}

angular
  .module('bringoz.admin.logistics-vehicle')
  .component('logisticsVehiclesDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      disabledIds: '<?',
      onChange: '&'
    },
    template: require('./logistics-vehicles-display-list.html').default,
    controller: LogisticsVehiclesDisplayListComponent
  });
